import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCheck } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { playDing } from "../lib/notifySound";

// Avviso allo studio: un cliente è entrato per la prima volta nella sua Area Riservata.
export const FirstAccessNotifier = () => {
  const { user, can } = useAuth();
  const navigate = useNavigate();
  const [queue, setQueue] = useState([]);
  const known = useRef(new Set());
  const on = !!user && !["cliente", "superadmin"].includes(user.role) && can("anagrafiche");

  const poll = useCallback(() => {
    api.get("/studio/area-cliente/primi-accessi").then(({ data }) => {
      const fresh = (data || []).filter((e) => !known.current.has(e.id));
      if (!fresh.length) return;
      fresh.forEach((e) => known.current.add(e.id));
      playDing();
      setQueue((q) => [...q, ...fresh]);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!on) return;
    poll();
    const id = setInterval(poll, 30000);
    return () => clearInterval(id);
  }, [on, poll]);

  const current = queue[0];
  if (!current) return null;
  const dismiss = () => { api.post(`/studio/area-cliente/primi-accessi/${current.id}/visto`).catch(() => {}); setQueue((q) => q.slice(1)); };
  const openNow = () => { dismiss(); navigate("/app/anagrafiche"); };
  const when = current.created_at ? new Date(current.created_at) : null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4" data-testid="first-access-popup">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl pgp-fade-up">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 shrink-0 rounded-full bg-amber-50 flex items-center justify-center"><UserCheck className="h-5 w-5 text-amber-600" /></div>
          <div>
            <p className="text-base font-semibold text-[#111827] break-words" data-testid="first-access-popup-text">
              {current.nome} è entrato per la prima volta nella sua Area Riservata
            </p>
            {when && <p className="text-sm text-[#6b7280] mt-1">{when.toLocaleDateString("it-IT")} alle {when.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}{current.email ? ` · ${current.email}` : ""}</p>}
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" onClick={dismiss} data-testid="first-access-close"
            className="rounded-lg border border-[#d1d5db] px-4 py-2 text-sm font-medium text-[#111827] hover:bg-[#F3F4F6] transition-colors">Chiudi</button>
          <button type="button" onClick={openNow} data-testid="first-access-anagrafiche"
            className="rounded-lg bg-[#1d4ed8] px-4 py-2 text-sm font-semibold text-white hover:bg-[#1e40af] transition-colors">Apri Anagrafiche</button>
        </div>
      </div>
    </div>
  );
};
